import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAynrQLr4t5JponbC-V5i1928mwoiTrozo",
  authDomain: "agreedly-b0f5e.firebaseapp.com",
  projectId: "agreedly-b0f5e",
  storageBucket: "agreedly-b0f5e.firebasestorage.app",
  messagingSenderId: "632529373617",
  appId: "1:632529373617:web:79bb7d672e00f071699590",
  measurementId: "G-DDYKRBS8X9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Connect to emulators for local development
if (window.location.hostname === "127.0.0.1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export default app;
export { app, auth, db, functions };